




import { Vue, Component } from "vue-property-decorator";
import Inbox from "../components/Inbox.vue";
import * as InboxStore from "../store/modules/inbox";
import { v4 as uuid4 } from "uuid";

@Component({
  components: {
    Inbox
  }
})
export default class Home extends Vue {
  get userId() {
    return InboxStore.getters.userId;
  }
  get deviceId() {
    return InboxStore.getters.deviceId;
  }

  mounted() {
    InboxStore.actions.loadStateFromLocalStorage();
    if (!this.deviceId) {
      InboxStore.mutations.setDeviceId(`broker/${uuid4()}`);
    }
    if (this.userId) {
      InboxStore.actions.loadMessages();
    } else {
      InboxStore.mutations.showSettings();
    }
  }
}
